var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 470,
    viewBox: "0 0 692 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2514_42608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625 30.8881H67C49.3269 30.8881 35 45.2149 35 62.8881V398.888C35 416.561 49.3269 430.888 67 430.888H520.307C537.98 430.888 552.307 416.561 552.307 398.888V278.673C552.307 269.444 556.292 260.664 563.239 254.587L646.068 182.135C653.015 176.058 657 167.278 657 158.049V62.8881C657 45.2149 642.673 30.8881 625 30.8881Z",
    fill: "url(#paint0_linear_2514_42608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 30.8881H67C49.3269 30.8881 35 45.2149 35 62.8881V398.888C35 416.561 49.3269 430.888 67 430.888H520.307C537.98 430.888 552.307 416.561 552.307 398.888V278.673C552.307 269.444 556.292 260.664 563.239 254.587L646.068 182.135C653.015 176.058 657 167.278 657 158.049V62.8881C657 45.2149 642.673 30.8881 625 30.8881Z",
    stroke: "#EAEAEA",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2514_42608",
    x: 0.5,
    y: 0.388062,
    width: 691,
    height: 469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.858824 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2514_42608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2514_42608",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_42608",
    x1: 657,
    y1: 405.174,
    x2: -3.5549,
    y2: 299.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562876"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector-4.512005c39d26b748d161989d50b92659.svg";
export { ForwardRef as ReactComponent };